const pinchZoom = (imageElement, minScale = 1, maxScale = 2) => {
    // exit if device is not touch-enabled
    if (window.matchMedia('(pointer:coarse)').matches === false) {
        return false;
    }

    let imageElementScale = 1;
    let start = {};
    const originalImageSize = imageElement.getBoundingClientRect();
    const swipeThreshold = window.innerWidth / 5;
    const verticalMargin = 100;
    const paddingBottom = 100;

    // distance between two fingers
    const distance = (event) => {
        return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    };
    // current translateX value
    const getTranslateValues = () => {
        var style = window.getComputedStyle(imageElement);
        var matrix = new WebKitCSSMatrix(style.webkitTransform);
        return {
            x: matrix.m41,
            y: matrix.m42,
        };
    }
    // current translateX value
    const getTranslateX = () => {
        var style = window.getComputedStyle(imageElement);
        var matrix = new WebKitCSSMatrix(style.webkitTransform);
        return matrix.m41;
    }
    // current translateY value
    const getTranslateY = () => {
        var style = window.getComputedStyle(imageElement);
        var matrix = new WebKitCSSMatrix(style.webkitTransform);
        return matrix.m42;
    }
    const disableSwipe = () => {
        $('.zoom-image-popup .slick-initialized').slick('slickSetOption', { touchMove: true, swipe: false });
    }
    const enableSwipe = () => {
        if ($('.zoom-image-popup .single').length === 0) {
            $('.zoom-image-popup .slick-initialized').slick('slickSetOption', { touchMove: true, swipe: true });
            imageElementScale = 1;
            start = {};
        }
    }
    const hideDots = () => {
        $('.zoom-image-popup .slick-dots, .zoom-image-popup .zoom-message').removeClass('fadein').addClass('fadeout');
    }
    const showDots = () => {
        $('.zoom-image-popup .slick-dots, .zoom-image-popup .zoom-message').removeClass('fadeout').addClass('fadein');
    }

    imageElement.addEventListener('touchstart', (event) => {
        if (event.touches.length === 2) {
            event.preventDefault();
            disableSwipe();

            // started position, distance between two fingers
            start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
            start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
            start.distance = distance(event);

        } else if (event.touches.length === 1 && imageElementScale > 1) {
            disableSwipe();

            start.x = event.touches[0].pageX;
            start.y = event.touches[0].pageY;
            // start.translateX = getTranslateX();
            // start.translateY = getTranslateY();
            const translateValues = getTranslateValues();
            start.translateX = translateValues.x;
            start.translateY = translateValues.y;
            start.width = imageElement.getBoundingClientRect().width;
            start.height = imageElement.getBoundingClientRect().height;
            start.paddingBottom = 100;
        }
    });

    imageElement.addEventListener('touchmove', (event) => {
        if (event.touches.length === 2) {
            event.preventDefault();

            let scale;
            if (event.scale) {
                // Safari provides event.scale
                scale = event.scale;
            } else {
                // other browsers do not have event.scale
                const newDistance = distance(event);
                scale = newDistance / start.distance;
            }

            let newScale;
            imageElementScale = typeof imageElementScale === "undefined" ? 1 : imageElementScale;

            if (scale > 1) {
                newScale = imageElementScale + ((scale - 1) * 0.1);
            } else {
                newScale = imageElementScale - (scale * 0.1);
            }

            imageElementScale = Math.min(Math.max(minScale, newScale), maxScale);

            const maxDeltaX = ((originalImageSize.width * imageElementScale) - window.innerWidth) / 2;
            const minDeltaX = (window.innerWidth - (originalImageSize.width * imageElementScale)) / 2;
            const actualDeltaX = (((event.touches[0].pageX + event.touches[1].pageX) / 2) - start.x) * 2;
            const heightDiff = (Math.abs((originalImageSize.height * imageElementScale) - (window.innerHeight)) / 2) + verticalMargin;
            const maxDeltaY = paddingBottom + heightDiff;
            const minDeltaY = paddingBottom - heightDiff;
            const actualDeltaY = (((event.touches[0].pageY + event.touches[1].pageY) / 2) - start.y) * 2;
            const deltaX = imageElementScale == 1 ? 0 : Math.min(Math.max(actualDeltaX, minDeltaX), maxDeltaX);
            const deltaY = imageElementScale == 1 ? 0 : Math.min(Math.max(actualDeltaY, minDeltaY), maxDeltaY);
            const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;

            imageElement.style.transform = transform;
            imageElement.style.WebkitTransform = transform;

            if (imageElementScale > 1) {
                hideDots();
            } else {
                showDots();
            }
            // 
        } else if (event.touches.length === 1 && imageElementScale > 1) {
            const maxDeltaX = (start.width - window.innerWidth) / 2;
            const minDeltaX = (window.innerWidth - start.width) / 2;
            const actualDeltaX = (event.touches[0].pageX - start.x);
            const heightDiff = (Math.abs(start.height - (window.innerHeight)) / 2) + verticalMargin;
            const maxDeltaY = paddingBottom + heightDiff;
            const minDeltaY = paddingBottom - heightDiff;
            const actualDeltaY = (event.touches[0].pageY - start.y);

            if (actualDeltaX + start.translateX > maxDeltaX + swipeThreshold
                || actualDeltaX + start.translateX < minDeltaX - swipeThreshold) {

                event.preventDefault();
                enableSwipe();

            } else {
                disableSwipe();

                const deltaX = Math.min(Math.max(actualDeltaX + start.translateX, minDeltaX), maxDeltaX);
                const deltaY = Math.min(Math.max(actualDeltaY + start.translateY, minDeltaY), maxDeltaY);
                const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;

                imageElement.style.transform = transform;
                imageElement.style.WebkitTransform = transform;
            }
        }
    });

    imageElement.addEventListener('touchend', (event) => {
        if (imageElementScale === 1) {
            enableSwipe();
        } else {
            disableSwipe();
        }
    });
}